// extracted by mini-css-extract-plugin
export default {"diffTargetable":"Diff-module__diffTargetable--hLfiB","diffHeaderWrapper":"Diff-module__diffHeaderWrapper--J03RC"};